/* eslint-disable max-len */
import styled from 'styled-components';
import { fontFamily, device } from '../../../constants';
import { fontSize } from '../../constants';

export const FilterSearch = styled.input`
  /* width: 56.3rem; */
  height: 4.5rem;
  margin-top: 1.5rem;
  border-radius: 1rem;
  border: none;
  box-shadow: inset 4px 4px 8px rgba(0, 0, 0, 0.1),
    inset -5px -5px 2px ${({ theme }) => theme.aux.secondary};
  background-color: ${({ theme }) => theme.core.secondary};
  font-size: 1.6rem;
  position: relative;
  padding: 0px 8rem 0px 1.5rem;
  z-index: 10;
  width: 100%;
  color: ${({ theme }) => theme.contrast.secondary};
  &:focus {
    outline: none;
  }
  &::placeholder {
    font-size: 1.6rem;
    font-family: ${fontFamily.circularMedium};
    /* color: ${({ theme }) => theme.contrast.primary}; */
  }
  position: relative;
`;

export const SearchMainContainer = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  width: 100%;
`;

export const SearchContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const Image = styled.div`
  /* width: ${({ width }) => `${width}rem`};
  height: ${({ width }) => `${width}rem`}; */

  & * {
    fill: ${({ theme }) => theme.contrast.primary} !important;
  }
`;

export const ImageFilter = styled.img`
  /* width: ${({ width }) => `${width}rem`};
  height: ${({ width }) => `${width}rem`}; */

  & * {
    fill: ${({ theme }) => theme.contrast.primary} !important;
  }
`;

// export const SearchIconSvg = styled.img`
//   width: 1.4rem;
//   height: 1.4rem;
//   @media ${device.tablet} {
//     width: 1.2rem;
//     height: 1.2rem;
//   }
// `;

export const CommonButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 1.5rem;
  display: flex;
`;

export const VerticalLine = styled.div`
  border-left: 2px solid #00000026;
  height: 20px;
  margin: 0 1rem;
`;

export const SearchButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  padding: 1rem;

  border-radius: 10px;
  height: 42px;
  /* width: 35px; */
  margin: 0px 0px 0px 1px;
  background-color: white;
  box-shadow: 4px 4px 6px #00000029;

  & * {
    fill: ${({ theme }) => theme.contrast.secondary} !important;
  }
`;

export const FilterButtom = styled.div`
  width: 5rem;
  height: 4.5rem;
  border-radius: 10px;
  margin: 0px 0px 0px 1px;
  background-color: ${({ theme }) => theme.aux.secondary};

  box-shadow: 4px 4px 6px #00000029;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 10;
  @media ${device.tablet} {
    display: none;
  }

  & svg {
    width: 2.5rem;
    height: 2.5rem;
  }
  & * {
    fill: ${({ theme }) => theme.contrast.primary} !important;
  }
`;

export const SearchDropDown = styled.div`
  position: absolute;
  width: calc(100% - 4rem);
  background-color: ${({ theme }) => theme.core.secondary};
  box-shadow: 0px 0px 10px #0000004f;
  z-index: 3;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  top: 4rem;
  left: 1px;
  height: 20rem;
  padding-top: 20px;
  animation: animHeight 300ms 1;
  overflow: auto;

  @keyframes animHeight {
    from {
      height: 0;
    }
    to {
      height: 20rem;
    }
  }
  @media ${device.tablet} {
    width: calc(100% - 2px);
    top: 3rem;
    left: 1px;
  }
`;

export const SearchResultText = styled.p`
  font-size: 1.4rem;
  font-family: ${fontFamily.circularBook};
  text-transform: uppercase;
  margin-left: 15px;
  color: ${({ theme }) => theme.contrast.primary};

  @media ${device.tablet} {
    font-size: 12px;
  }
`;

export const SearchTextContainer = styled.div`
  width: 100%;
  height: 5rem;
  display: flex;
  align-items: center;
`;

export const SearchDetailsContainer = styled.div`
  width: 100%;
  margin: 1rem 0;
  background-color: #eeeff5;
  border-radius: 1rem;
  padding: 1.4rem;
  border: 2px solid ${({ theme }) => theme.core.secondary};
  &.selected {
    border: 2px solid ${({ theme }) => theme.core.loginPrimary};
  }
`;

export const SearchResultContent = styled.div``;

export const SearchItemLabel = styled.span`
  font-size: ${fontSize.text};
  font-family: ${fontFamily.circularBook};
  color: ${({ theme }) => theme.text.gray};
`;

export const SearchItemValue = styled.span`
  font-size: ${fontSize.text};
  font-family: ${fontFamily.circularMedium};
  color: ${({ theme }) => theme.text.gray};
`;

export const SearchPath = styled.div`
  font-size: ${fontSize.text};
  font-family: ${fontFamily.circularMedium};
  color: ${({ theme }) => theme.text.gray};
  /* margin-top: 1rem; */
`;
